import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=5477a6ee&scoped=true"
import script from "./ChatPopup.vue?vue&type=script&lang=js"
export * from "./ChatPopup.vue?vue&type=script&lang=js"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=5477a6ee&prod&lang=scss&scoped=true"
import style1 from "./ChatPopup.vue?vue&type=style&index=1&id=5477a6ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477a6ee",
  null
  
)

export default component.exports